/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
class t{constructor(t,s,i,o){this.targetPoint=t,this.constraint=s,this.isDraped=i,this.domain=o}}export{t as SnappingCandidate};
